import app from '@/app';
import templateUrl from './plan-materials-services.html';

/* @ngInject */
function controller(
	$controller,
	$http,
	$httpParamSerializer,
	$rootScope,
	$state,
	$translate,
	DialogService,
	wfPager2Service,
	PAGE_SIZES,
	SMALL_PAGE_SIZES,
	Principal
) {
	var $ctrl = this;

	$ctrl.currentAccount = null;

	Principal.identity().then(account => {
		$ctrl.currentAccount = account;
	});

	$controller('AbstractController', { $ctrl: $ctrl });

	$ctrl.yearSizes = SMALL_PAGE_SIZES;
	$ctrl.segmentSizes = PAGE_SIZES;

	var transition = $ctrl.transition;
	$ctrl.transition = function(params) {
		transition(params);

		$ctrl.milestonePage = params.milestonePage != null ? parseInt(params.milestonePage) : 0;
		$ctrl.milestoneSize =
			params.milestoneSize != null ? parseInt(params.milestoneSize) : PAGE_SIZES[3];
		$ctrl.milestoneCount =
			1 +
			($ctrl.entity.tailMilestone - $ctrl.entity.headMilestone) / $ctrl.entity.segmentLength;

		const milestoneRange = wfPager2Service.createPage(
			$ctrl.milestonePage,
			$ctrl.milestoneSize,
			$ctrl.milestoneCount,
			$ctrl.entity.segmentLength,
			$ctrl.entity.headMilestone
		);
		$ctrl.headMilestone = milestoneRange.head;
		$ctrl.tailMilestone = milestoneRange.tail;

		$ctrl.yearPage = params.yearPage != null ? parseInt(params.yearPage) : 0;
		$ctrl.yearSize = params.yearSize != null ? parseInt(params.yearSize) : SMALL_PAGE_SIZES[0];

		const yearRange = wfPager2Service.createPage(
			$ctrl.yearPage,
			$ctrl.yearSize,
			$ctrl.entity.processedYears,
			1,
			$ctrl.entity.headYear
		);
		$ctrl.headYear = yearRange.head;
		$ctrl.tailYear = yearRange.tail;

		$ctrl.direction = params.direction;
		$ctrl.lanes = params.lanes;

		const query = _.pick([
			'headMilestone',
			'tailMilestone',
			'headYear',
			'tailYear',
			'direction',
			'lanes'
		])($ctrl);

		// The export always carries the whole plan: no screen filter is forwarded.
		$ctrl.exportLink = 'api/plans/' + $ctrl.entity.id + '/results/materialsservices/excel';

		load(query);
	};

	function load(query) {
		// Keeps the global loading overlay up during the fetch, as in plan-result:
		// it runs after UI-Router already cleared isTransitioning.
		$ctrl.isSearching = true;
		$rootScope.isLoadingResults = true;
		$http
			.get('api/plans/' + $ctrl.entity.id + '/results/materialsservices', { params: query })
			.then(function(response) {
				$ctrl.result = response.data;
			})
			.finally(function() {
				$ctrl.isSearching = false;
				$rootScope.isLoadingResults = false;
			});
	}

	$ctrl.laneLabel = function(column) {
		return column.lane == 100
			? $translate.instant('unifilar_parameters.shoulder')
			: $translate.instant('unifilar_parameters.carril') + ' ' + column.lane;
	};

	// A year band spans every column of the same year; only the first one renders it.
	$ctrl.isFirstOfYear = function(index) {
		const columns = $ctrl.result.columns;
		return index === 0 || columns[index - 1].year !== columns[index].year;
	};

	$ctrl.yearSpan = function(index) {
		return countWhile($ctrl.result.columns, index, column => column.year === $ctrl.result.columns[index].year);
	};

	$ctrl.isFirstOfDirection = function(index) {
		const columns = $ctrl.result.columns;
		return (
			index === 0 ||
			columns[index - 1].year !== columns[index].year ||
			columns[index - 1].direction !== columns[index].direction
		);
	};

	$ctrl.directionSpan = function(index) {
		const current = $ctrl.result.columns[index];
		return countWhile(
			$ctrl.result.columns,
			index,
			column => column.year === current.year && column.direction === current.direction
		);
	};

	function countWhile(columns, index, matches) {
		let length = 0;
		while (index + length < columns.length && matches(columns[index + length])) {
			++length;
		}
		return length;
	}

	$ctrl.isExporting = false;

	$ctrl.downloadExcel = function(url) {
		$ctrl.isExporting = true;
		DialogService.alertMessage($translate.instant('action.exportDownloading'));
		$http
			.get(url, { responseType: 'blob' })
			.then(function(response) {
				var blob = new Blob([response.data], {
					type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
				});
				var link = document.createElement('a');
				link.href = URL.createObjectURL(blob);
				var cd = response.headers('content-disposition');
				link.download = cd
					? cd.split('filename=')[1].replace(/^[\s'";]+|[\s'";]+$/g, '')
					: 'materials-services.xlsx';
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
				URL.revokeObjectURL(link.href);
			})
			.catch(function() {
				DialogService.alertMessage($translate.instant('action.exportError'));
			})
			.finally(function() {
				$ctrl.isExporting = false;
			});
	};

	let onQueryTimeout = null;

	$ctrl.onQueryChange = function() {
		if (onQueryTimeout) {
			clearTimeout(onQueryTimeout);
		}

		onQueryTimeout = setTimeout(() => {
			$state.go(
				$state.current,
				{
					milestonePage: $ctrl.milestonePage,
					milestoneSize: $ctrl.milestoneSize,
					yearPage: $ctrl.yearPage,
					yearSize: $ctrl.yearSize,
					direction: $ctrl.direction,
					lanes: $ctrl.lanes
				},
				{ reload: true }
			);
		}, 400);
	};

	$ctrl.onMilestonePageChange = function(page, size) {
		$state.go($state.current, { milestonePage: page, milestoneSize: size }, { reload: true });
	};

	$ctrl.onYearPageChange = function(page, size) {
		$state.go($state.current, { yearPage: page, yearSize: size }, { reload: true });
	};
}

const component = {
	templateUrl,
	controller,
	bindings: {
		$transition$: '<',
		entity: '<'
	}
};

app.component('planMaterialsServices', component);
